<template>
  <div class="text-left mt-6">
    <input
      id="csv"
      type="file"
      name="csv"
      accept=".csv"
      class="mt-6 block text-sm leading-5 font-medium text-gray-700"
      @change="handleFileSelected"
    />
    <TextInput
      v-model="requiredFieldKeys.segment"
      class="mt-4"
      label="Segment Name"
      placeholder="The best contact list ever"
    />
    <p v-if="uploadError" id="phone-error" class="mt-2 text-sm text-red-600">{{ uploadError }}</p>
    <div v-if="showKeys" class="mt-6">
      <h2 class="mt-6 text-lg leading-7 font-medium text-gray-900">
        Required fields
        <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
          >{{ data.length }} Records</span
        >
      </h2>
      <div class="flex w-full">
        <SelectMenu
          class="w-1/3 mt-2 mr-2"
          title="Name"
          :initial-value="dataKeys.filter(item => item.includes('name'))[0]"
          :options="dataKeys"
          @selected-option="selectedOption($event, 'name')"
        />
        <SelectMenu
          class="w-1/3 mt-2 mr-2"
          title="Email"
          :initial-value="dataKeys.filter(item => item.includes('email'))[0]"
          :options="dataKeys"
          @selected-option="selectedOption($event, 'email')"
        />
        <SelectMenu
          class="w-1/3 mt-2"
          title="Phone Number"
          :initial-value="dataKeys.filter(item => item.includes('phone'))[0]"
          :options="dataKeys"
          @selected-option="selectedOption($event, 'phone')"
        />
      </div>
      <p class="mt-2 text-xs leading-5 text-gray-700 break-words">{{ customFields }}</p>
      <h2 class="mt-6 text-lg leading-7 font-medium text-gray-900">Preview</h2>
      <div class="mt-2 flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table class="min-w-full divide-y divide-gray-200">
                <thead>
                  <tr>
                    <th
                      class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Name
                    </th>
                    <th
                      class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Email
                    </th>
                    <th
                      class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                    >
                      Phone
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr v-for="previewContact in previewData" :key="previewContact.email" class="bg-white">
                    <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 font-medium text-gray-900">
                      {{ previewContact[requiredFieldKeys.name] }}
                    </td>
                    <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                      {{ previewContact[requiredFieldKeys.email] }}
                    </td>
                    <td class="px-6 py-4 whitespace-no-wrap text-sm leading-5 text-gray-500">
                      {{ previewContact[requiredFieldKeys.phone] }}
                    </td>
                  </tr>

                  <!-- More rows... -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Papa from 'papaparse';
import SelectMenu from '../shared/SelectMenu.vue';

export default {
  components: {
    SelectMenu,
  },
  props: ['modelValue'],
  data() {
    return {
      data: [],
      previewData: [],
      dataKeys: [],
      showKeys: false,
      requiredFieldKeys: {
        name: '',
        email: '',
        phone: '',
        segment: '',
      },
      uploadError: '',
    };
  },
  computed: {
    customFields() {
      const self = this;
      let filteredCustomFields = this.dataKeys.filter(item => {
        return ![self.requiredFieldKeys.email, self.requiredFieldKeys.phone, self.requiredFieldKeys.name].includes(
          item
        );
      });
      return `The following columns will be uploaded as custom fields on the contact: ${filteredCustomFields
        .toString()
        .replaceAll(',', ', ')}`;
    },
  },
  methods: {
    handleFileSelected(e) {
      const self = this;
      self.$store.commit('general/showLoadingSpinner');
      if (e.target.files[0].size > 5000000) {
        self.uploadError =
          'The file you have uploaded is greater than 5MB. Please upload a file less than 5MB in size.';
        self.$store.commit('general/hideLoadingSpinner');
      } else {
        Papa.parse(e.target.files[0], {
          header: true,
          skipEmptyLines: true,
          complete: data => {
            self.completedParse(data, e.target.files[0].name);
          },
        });
      }
    },
    completedParse(file, name) {
      const self = this;
      self.$store.commit('general/hideLoadingSpinner');
      let preview = [];
      file.data.slice([0], [10]).map(item => {
        preview.push(item);
      });
      self.previewData = preview;
      self.data = file.data;
      self.dataKeys = file.meta.fields;
      self.showKeys = true;
      self.requiredFieldKeys.segment == '' ? (self.requiredFieldKeys.segment = name) : self.requiredFieldKeys.segment;
      self.$emit('update:modelValue', { data: self.data, required_keys: self.requiredFieldKeys, file_name: name });
    },
    selectedOption(e, key) {
      const self = this;
      if (key == 'name') {
        self.requiredFieldKeys.name = e;
      } else if (key == 'email') {
        self.requiredFieldKeys.email = e;
      } else {
        self.requiredFieldKeys.phone = e;
      }
    },
  },
};
</script>
